export const types = {
    // UPDATE TYPES FOR USER AND MEMBERSHIP
    initialized: "[Auth] Initialized",
    login: "[Auth] Login",
    logout: "[Auth] Logout",

    addUser: "[Account] Load user",
    delUser: "[Account] Del user",
    updateUser: "[Account] Update user",
    updateMembership: "[Account] Update membership",
    updateNutritionalProfile: "UPDATE_NUTRITIONAL_PROFILE_DATA",

    updateGeolocation: "UPDATE_GEOLOCATION_DATA",

    updateLanguage: "UPDATE_LANGUAGE_DATA",

    updateNavigator: "[Navigator] Update action navigation",
    updateCurrentSection: "[Navigator] Update content section",

    loginAdmin: "LOGIN_ADMIN",
    logoutAdmin: "LOGOUT_ADMIN",

    updateMaterialUILightTheme: "[MUI Light Theme] Update material light theme",
    restartMaterialUILightTheme: "[MUI Light Theme] Restart to default light theme",

    updateMaterialUIDarkTheme: "[MUI Dark Theme] Update material dark theme",
    restartMaterialUIDarkTheme: "[MUI Dark Theme] Restart to default theme",

    updateConfigHanuTheme: "[Config Hanu Theme] Update config Hanu Theme",
    deleteConfigHanuTheme: "[Config Hanu Theme] Delete config Hanu Theme",
    updatePreferDarkMode: "[Config Hanu Theme] Update prefer dark mode",

    loadingProfile: "[Profiles] Loading Profile",
    selectProfile: "[Profiles] Select Profile",
    setAvailableProfiles: "[Profiles] Set available profiles",
    updateTTL: "[Profiles] Update TTL Profiles",

    updatePartnerList: "[Partners List] Update partner list",
};
